import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useApi } from "../../../hooks/useApi"
import { CSVUploadResponse } from "../../../../api/trading"

const useUploadDatasetCSVMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: CSVUploadResponse) => void
  onError: (error: AxiosError<{ error: string }>) => void
}) => {
  const { scientApi } = useApi()

  return useMutation(scientApi.trading.uploadDatasetsCSV, { onSuccess, onError })
}

export default useUploadDatasetCSVMutation

